import { Grid, Typography } from "@mui/material";
import { TabHeader } from "./TabHeader";
import { useContext } from "react";
import { GameContext } from "../../provider/GameProvider";

export default function StatisticsTab() {
  const { game } = useContext(GameContext);
  return (
    <Grid container spacing={2} style={{ paddingBottom: 180 }}>
      <TabHeader />
      <Grid item md={12} xs={12} style={{ paddingBottom: 24 }}>
        <Typography
          variant="h5"
          style={{ textAlign: "center", color: "lightblue" }}
        >
          Statistics
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <div>You have played for {formatElapsedTimeDiff(game.createdAt)}</div>
      </Grid>
      <Grid item xs={12}>
        <div>You had {game.molecule.creations} Molecule-Creations</div>
      </Grid>
      <Grid item xs={12} style={{ paddingTop: 32 }}>
        <div style={{ fontWeight: "bold" }}>Last 10 Molecule-Creations</div>
      </Grid>
      <Grid item xs={12}>
        <div style={{ display: "block" }}>
          {game.last10MoleculeCreations.map((creation, index) => {
            const diff = creation.endedAt - creation.startedAt;
            const formatedDiff = formatElapsedTime(diff);
            return (
              <div key={index}>
                Creation took {formatedDiff} and gave{" "}
                {creation.molecules.toString()} Molecules
              </div>
            );
          })}
        </div>
      </Grid>
    </Grid>
  );
}

function formatElapsedTimeDiff(ms: number) {
  const diff = Date.now() - ms;

  return formatElapsedTime(diff);
}

function formatElapsedTime(diff: number) {
  let seconds = Math.floor(diff / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let days = Math.floor(hours / 24);
  let years = Math.floor(days / 365);

  days -= years * 365;
  hours -= days * 24 + years * 365 * 24;
  minutes -= hours * 60 + days * 24 * 60 + years * 365 * 24 * 60;
  seconds -=
    minutes * 60 +
    hours * 60 * 60 +
    days * 24 * 60 * 60 +
    years * 365 * 24 * 60 * 60;

  const y = years > 0 ? `${years} year${years > 1 ? "s" : ""}, ` : "";
  const d = days > 0 ? `${days} day${days > 1 ? "s" : ""}, ` : "";
  const h = hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}, ` : "";
  const m = minutes > 0 ? `${minutes} minute${minutes > 1 ? "s" : ""}, ` : "";
  const s = seconds > 0 ? `${seconds} second${seconds > 1 ? "s" : ""}` : "";

  return `${y}${d}${h}${m}${s}`.replace(/,\s*$/, "");
}
